import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthService from "../../services/AuthService";

/** Signed-in users can open tutor pages. Guests go to login. */
export default function RequireTutor({ children }) {
    const location = useLocation();
    const [state, setState] = useState("loading");

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const auth = await AuthService.isAuthenticated();
                if (!cancelled) setState(auth ? "ok" : "guest");
            } catch {
                if (!cancelled) setState("guest");
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    if (state === "loading") {
        return null;
    }
    if (state === "guest") {
        return <Navigate to="/login" replace state={{ from: { pathname: location.pathname } }} />;
    }
    return children;
}
